import { Grid2 } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Box, Stack, Typography, useTheme } from '@mui/material';
// import { ItemCard, ReportAccordian, ReportGroupChart, ReportSingleChart } from '@aibees/elephant/components';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type {
  ItemProgressType,
  EnrichedResultItemProps as Props,
} from './types';
// import { ItemProgress } from './components/item-progress';
import { ItemCard } from '../item-card';
import { ItemProgress } from '../item-progress';
import { ReportAccordian } from '../report-accordian';
import { ReportGroupChart } from '../report-group-chart';
import { ReportSingleChart } from '../report-single-chart';

export const EnrichedResultItem = memo(({ className, title }: Props) => {
  const { palette } = useTheme();

  const records: ItemProgressType[] = [
    {
      title: 'Total Rows',
      value: '1000',
      percent: '100',
      color: palette.primary[500],
    },
    {
      title: 'Matched',
      value: '945',
      percent: '94.5',
      color: palette.success[500],
    },
    {
      title: 'Failed',
      value: '25',
      percent: '2.5',
      color: palette.error[500],
    },
  ];

  return (
    <Styled.Wrapper
      className={classnames('EnrichedResultItem', className)}
      sx={SX.root}
    >
      <ReportAccordian title={`${title} Enrichment`}>
        <Grid2 container columns={12} columnSpacing={1.5} sx={SX.content}>
          <Grid2 xs={4}>
            <ItemCard title={`Contacts ${title} Enriched`} creditCost="-3,780">
              <Stack sx={SX.itemWrapper} gap={2.5}>
                {records.map((i) => (
                  <ItemProgress key={i.title} item={i} />
                ))}
              </Stack>
            </ItemCard>
          </Grid2>
          <Grid2 xs={4}>
            <ItemCard title={`Contacts ${title} Enriched`}>
              <Box sx={SX.chartGroup}>
                <Stack
                  justifyContent="center"
                  alignItems="center"
                  sx={SX.chartGroupLabel}
                >
                  <Typography sx={SX.Label}>945</Typography>
                  <Typography sx={SX.description}>
                    Total Record Submitted
                  </Typography>
                </Stack>
                <ReportGroupChart />
              </Box>
            </ItemCard>
          </Grid2>
          <Grid2 xs={4}>
            <ItemCard title={`Contacts ${title} Enriched`}>
              <Stack
                sx={{ mt: 6, ml: (p) => p.spacing(-3) }}
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                gap={3}
              >
                <ReportSingleChart
                  value={81}
                  title="After"
                  color={palette.success.main}
                />
                <ReportSingleChart
                  value={81}
                  title="After"
                  color={palette.warning[500]}
                />
              </Stack>
            </ItemCard>
          </Grid2>
        </Grid2>
      </ReportAccordian>
    </Styled.Wrapper>
  );
});

EnrichedResultItem.displayName = 'EnrichedResultItem';
